import { render, staticRenderFns } from "./FilterDrawer.vue?vue&type=template&id=520877d5&"
import script from "./FilterDrawer.vue?vue&type=script&lang=js&"
export * from "./FilterDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports